// extracted by mini-css-extract-plugin
module.exports = {"Image":"Error_Image__pH956","Title":"Error_Title__12cDB"};